import { Content, Spacer } from 'components';
import * as React from 'react';
export default {
  Content,
  Spacer,
  React
};